<div class="new-template">
  <div class="template-form">
    <div class="template-form-inner">
      <form [formGroup]="templateForm">
        <div class="template-title">
          <h3 *ngIf="!isEditMode; else elseBlock">Add new Template</h3>
          <ng-template #elseBlock>
            <h3>Edit Template</h3>
          </ng-template>
          <mat-form-field appearance="outline" class="title-input" [hideRequiredMarker]="true">
            <mat-label>Template Name</mat-label>
            <input
              formControlName="template"
              type="text"
              matInput
              placeholder=""
            />
            <mat-error
              *ngFor="let validation of account_validation_messages.template"
            >
              <mat-error
                class="error-message"
                *ngIf="
                  templateForm.get('template')?.hasError(validation.type) &&
                  (templateForm.get('template')?.dirty ||
                    templateForm.get('template')?.touched)
                "
                >{{ validation.message }}</mat-error
              >
            </mat-error>
          </mat-form-field>
          <mat-icon (click)="close()" class="close-button">clear</mat-icon>
        </div>
        <div class="template-body">
          <div class="template-left">
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>Id</mat-label>
              <input type="text" matInput placeholder="" disabled />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>Company</mat-label>
              <input type="text" matInput placeholder="" disabled />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>Date</mat-label>
              <input type="text" matInput placeholder="" disabled />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>PIB</mat-label>
              <input type="text" matInput placeholder="" disabled />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>More</mat-label>
              <input type="text" matInput placeholder="" disabled />
            </mat-form-field>
          </div>
          <div class="template-right">
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>_Id</mat-label>
              <input formControlName="id" type="text" matInput placeholder="" />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>_Company</mat-label>
              <input
                formControlName="company"
                type="text"
                matInput
                placeholder=""
              />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>_Date</mat-label>
              <input
                formControlName="date"
                type="date"
                matInput
                placeholder=""
              />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>_PIB</mat-label>
              <input
                formControlName="pib"
                type="text"
                matInput
                placeholder=""
              />
            </mat-form-field>
            <mat-form-field appearance="outline" [hideRequiredMarker]="true">
              <mat-label>More</mat-label>
              <input
                formControlName="more"
                type="text"
                matInput
                placeholder=""
              />
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="!isEditMode" class="buttonDiv">
          <button
            mat-button
            class="add-client-button"
            type="submit"
            (click)="submit()"
            [disabled]="!templateForm.valid"
          >
            {{ btnText }}
          </button>
        </div>
        <div *ngIf="isEditMode" class="buttonDiv">
          <button
            mat-button
            class="add-client-button"
            type="submit"
            (click)="editTemplate(id)"
          >
            {{ btnText }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
